export default __webpack_public_path__ + "static/media/server.8930f720.svg";